import { AppRoute } from 'src/app/routing/routing.config';

export const gtmEventElementRoutePrefix: Record<AppRoute, string> = {
  [AppRoute.WELCOME]: 'Welcome',
  [AppRoute.NEW_USER]: 'New User',
  [AppRoute.REGISTERED_USER]: 'Registered User',
  [AppRoute.SUBSCRIBED_USER]: 'Subscribed User',
  [AppRoute.PRIVACY_POLICY]: 'Provacy Policy',
  [AppRoute.TERMS_AND_CONDITIONS]: 'T&C',
  [AppRoute.ERROR_PAGE]: 'Error Page',
  [AppRoute.APP_START]: 'App Start',
  [AppRoute.APP_LOGIN]: 'App Login',
  [AppRoute.APP_LOGOUT]: 'App Logout',
};
